import { propertiesToInlineStyles } from '../components/style-plugins/index.js';
import { ALL_STATES } from '../components/pseudo-classes.js';
import { BREAKPOINTS } from '../constants.js';

// Standard Tailwind Colors for Preview Fallback
export const TAILWIND_COLORS = {
    slate: { 50: '#f8fafc', 100: '#f1f5f9', 200: '#e2e8f0', 300: '#cbd5e1', 400: '#94a3b8', 500: '#64748b', 600: '#475569', 700: '#334155', 800: '#1e293b', 900: '#0f172a', 950: '#020617' },
    gray: { 50: '#f9fafb', 100: '#f3f4f6', 200: '#e5e7eb', 300: '#d1d5db', 400: '#9ca3af', 500: '#6b7280', 600: '#4b5563', 700: '#374151', 800: '#1f2937', 900: '#111827', 950: '#030712' },
    zinc: { 50: '#fafafa', 100: '#f4f4f5', 200: '#e4e4e7', 300: '#d4d4d8', 400: '#a1a1aa', 500: '#71717a', 600: '#52525b', 700: '#3f3f46', 800: '#27272a', 900: '#18181b', 950: '#09090b' },
    neutral: { 50: '#fafafa', 100: '#f5f5f5', 200: '#e5e5e5', 300: '#d4d4d4', 400: '#a3a3a3', 500: '#737373', 600: '#525252', 700: '#404040', 800: '#262626', 900: '#171717', 950: '#0a0a0a' },
    stone: { 50: '#fafaf9', 100: '#f5f5f4', 200: '#e7e5e4', 300: '#d6d3d1', 400: '#a8a29e', 500: '#78716c', 600: '#57534e', 700: '#44403c', 800: '#292524', 900: '#1c1917', 950: '#0c0a09' },
    red: { 50: '#fef2f2', 100: '#fee2e2', 200: '#fecaca', 300: '#fca5a5', 400: '#f87171', 500: '#ef4444', 600: '#dc2626', 700: '#b91c1c', 800: '#991b1b', 900: '#7f1d1d', 950: '#450a0a' },
    orange: { 50: '#fff7ed', 100: '#ffedd5', 200: '#fed7aa', 300: '#fdba74', 400: '#fb923c', 500: '#f97316', 600: '#ea580c', 700: '#c2410c', 800: '#9a3412', 900: '#7c2d12', 950: '#431407' },
    amber: { 50: '#fffbeb', 100: '#fef3c7', 200: '#fde68a', 300: '#fcd34d', 400: '#fbbf24', 500: '#f59e0b', 600: '#d97706', 700: '#b45309', 800: '#92400e', 900: '#78350f', 950: '#451a03' },
    yellow: { 50: '#fefce8', 100: '#fef9c3', 200: '#fef08a', 300: '#fde047', 400: '#facc15', 500: '#eab308', 600: '#ca8a04', 700: '#a16207', 800: '#854d0e', 900: '#713f12', 950: '#422006' },
    lime: { 50: '#f7fee7', 100: '#ecfccb', 200: '#d9f99d', 300: '#bef264', 400: '#a3e635', 500: '#84cc16', 600: '#65a30d', 700: '#4d7c0f', 800: '#3f6212', 900: '#365314', 950: '#1a2e05' },
    green: { 50: '#f0fdf4', 100: '#dcfce7', 200: '#bbf7d0', 300: '#86efac', 400: '#4ade80', 500: '#22c55e', 600: '#16a34a', 700: '#15803d', 800: '#166534', 900: '#14532d', 950: '#052e16' },
    emerald: { 50: '#ecfdf5', 100: '#d1fae5', 200: '#a7f3d0', 300: '#6ee7b7', 400: '#34d399', 500: '#10b981', 600: '#059669', 700: '#047857', 800: '#065f46', 900: '#064e3b', 950: '#022c22' },
    teal: { 50: '#f0fdfa', 100: '#ccfbf1', 200: '#99f6e4', 300: '#5eead4', 400: '#2dd4bf', 500: '#14b8a6', 600: '#0d9488', 700: '#0f766e', 800: '#115e59', 900: '#134e4a', 950: '#042f2e' },
    cyan: { 50: '#ecfeff', 100: '#cffafe', 200: '#a5f3fc', 300: '#67e8f9', 400: '#22d3ee', 500: '#06b6d4', 600: '#0891b2', 700: '#0e7490', 800: '#155f75', 900: '#164e63', 950: '#083344' },
    sky: { 50: '#f0f9ff', 100: '#e0f2fe', 200: '#bae6fd', 300: '#7dd3fc', 400: '#38bdf8', 500: '#0ea5e9', 600: '#0284c7', 700: '#0369a1', 800: '#075985', 900: '#0c4a6e', 950: '#082f49' },
    blue: { 50: '#eff6ff', 100: '#dbeafe', 200: '#bfdbfe', 300: '#93c5fd', 400: '#60a5fa', 500: '#3b82f6', 600: '#2563eb', 700: '#1d4ed8', 800: '#1e40af', 900: '#1e3a8a', 950: '#172554' },
    indigo: { 50: '#eef2ff', 100: '#e0e7ff', 200: '#c7d2fe', 300: '#a5b4fc', 400: '#818cf8', 500: '#6366f1', 600: '#4f46e5', 700: '#4338ca', 800: '#3730a3', 900: '#312e81', 950: '#1e1b4b' },
    violet: { 50: '#f5f3ff', 100: '#ede9fe', 200: '#ddd6fe', 300: '#c4b5fd', 400: '#a78bfa', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9', 800: '#5b21b6', 900: '#4c1d95', 950: '#2e1065' },
    purple: { 50: '#faf5ff', 100: '#f3e8ff', 200: '#e9d5ff', 300: '#d8b4fe', 400: '#c084fc', 500: '#a855f7', 600: '#9333ea', 700: '#7e22ce', 800: '#6b21a8', 900: '#581c87', 950: '#3b0764' },
    fuchsia: { 50: '#fdf4ff', 100: '#fae8ff', 200: '#f5d0fe', 300: '#f0abfc', 400: '#e879f9', 500: '#d946ef', 600: '#c026d3', 700: '#a21caf', 800: '#86198f', 900: '#701a75', 950: '#4a044e' },
    pink: { 50: '#fdf2f8', 100: '#fce7f3', 200: '#fbcfe8', 300: '#f9a8d4', 400: '#f472b6', 500: '#ec4899', 600: '#db2777', 700: '#be185d', 800: '#9d174d', 900: '#831843', 950: '#500724' },
    rose: { 50: '#fff1f2', 100: '#ffe4e6', 200: '#fecdd3', 300: '#fda4af', 400: '#fb7185', 500: '#f43f5e', 600: '#e11d48', 700: '#be123c', 800: '#9f1239', 900: '#881337', 950: '#4c0519' },
};

/**
 * Parser for converting between Tailwind classes and property objects
 * Uses the plugin system for property definitions
 *
 * ARCHITECTURE:
 * - variant-data-[] is the SINGLE SOURCE OF TRUTH for variant properties
 * - Properties are stored as JSON in variant-data-[] format in class strings
 * - At render time, variant-data is converted to actual Tailwind classes via propertiesToClasses()
 * - parseStates() reads Tailwind classes to understand state/breakpoint structure
 */
export class TailwindParser {
    /**
     * Encode property object to base64 format
     * This is the STORAGE format - single source of truth
     * @param {Object} props - Property object
     * @returns {string} Base64 encoded string (without variant-data-[] wrapper)
     */
    static encodeData(props) {
        try {
            const json = JSON.stringify(props);
            const b64 = btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            return b64;
        } catch (e) {
            console.error('Failed to encode variant data', e);
            return '';
        }
    }

    /**
     * Decode base64 data to property object
     * @param {string} b64 - Base64 encoded string
     * @returns {Object|null} Decoded property object
     */
    static decodeData(b64) {
        if (!b64) return null;

        try {
            // Decode base64
            const decoded = b64.replace(/-/g, '+').replace(/_/g, '/');
            const padded = decoded.padEnd(decoded.length + (4 - decoded.length % 4) % 4, '=');
            const json = atob(padded);
            return JSON.parse(json);
        } catch (e) {
            console.warn('Failed to decode variant data', e);
            return null;
        }
    }


    /**
     * Parses a class string containing variant-data-[] with breakpoint/state prefixes
     * into style objects organized by breakpoint and state
     *
     * Input format: "variant-data-[...] md:hover:variant-data-[...] lg:variant-data-[...]"
     * Output: { default: { normal: {styles}, hover: {styles} }, md: { normal: {styles} }, ... }
     *
     * @param {string} classString - Class string with prefixed variant-data-[]
     * @param {Function} resolveColor - Color resolver function
     * @returns {Object} Nested object: { breakpoint: { state: styleObject } }
     */
    static parseStates(classString, resolveColor) {
        const bpKeys = Object.keys(BREAKPOINTS);
        const result = {};

        // Initialize structure
        bpKeys.forEach(bp => {
            result[bp] = {};
            ALL_STATES.forEach(state => {
                result[bp][state.value] = {};
            });
        });

        const classes = (classString || '').split(' ').filter(c => c);

        classes.forEach(cls => {
            // Skip if not variant-data
            if (!cls.includes('variant-data-[')) return;

            // Parse prefixes: "md:hover:variant-data-[...]"
            let activeBP = 'default';
            let activeState = 'normal';
            let processedClass = cls;

            // Extract breakpoint prefix
            for (const bp of bpKeys) {
                if (bp === 'default') continue;
                if (processedClass.startsWith(`${bp}:`)) {
                    activeBP = bp;
                    processedClass = processedClass.substring(bp.length + 1);
                    break;
                }
            }

            // Extract state prefix
            const matchedState = ALL_STATES.find(s => s.prefix && processedClass.startsWith(s.prefix));
            if (matchedState) {
                activeState = matchedState.value;
                processedClass = processedClass.substring(matchedState.prefix.length);
            }

            // Decode variant-data and convert to styles
            const props = this.parse(processedClass);
            const styles = this.toStyle(props, resolveColor);

            // Merge into result
            Object.assign(result[activeBP][activeState], styles);
        });

        return result;
    }

    /**
     * Parse a class string containing variant-data-[] into a property object
     * This reads the SINGLE SOURCE OF TRUTH (variant-data-[])
     * @param {string} classList - String containing variant-data-[]
     * @returns {Object} Property object with keys and values
     */
    static parse(classList) {
        if (!classList) return {};

        // Extract base64 from variant-data-[] wrapper
        let b64 = null;
        if (classList.includes('variant-data-[')) {
            const match = classList.match(/variant-data-\[([^\]]+)\]/);
            if (match && match[1]) {
                b64 = match[1];
            }
        }

        if (!b64) return {};

        const decoded = this.decodeData(b64);

        const filteredDecoded = decoded ? Object.fromEntries(
            Object.entries(decoded).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        ) : {};

        return filteredDecoded;
    }

    /**
     * Generate variant-data-[] class string from a property object
     * This creates the SINGLE SOURCE OF TRUTH storage format
     * @param {Object} props - Property object with keys and values
     * @returns {string} variant-data-[] encoded class string
     */
    static generate(props) {
        if (!props || Object.keys(props).length === 0) return '';

        const filteredProps = Object.fromEntries(
            Object.entries(props).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        );

        if (Object.keys(filteredProps).length === 0) return '';

        const b64 = this.encodeData(filteredProps);
        return `variant-data-[${b64}]`;
    }

    /**
     * Convert property object to inline CSS styles
     * @param {Object} props - Property object with keys and values
     * @param {Function} resolveColor - Function to resolve theme color keys to CSS colors
     * @returns {Object} CSS style object
     */
    static toStyle(props, resolveColor) {
        // First get inline styles for hex/rgb/hsl colors from plugin system
        const pluginStyles = propertiesToInlineStyles(props, resolveColor);

        // Then add additional computed styles for layout/typography
        const computedStyles = {};

        // Helper functions for converting values
        const FONT_SIZES = { xs: '12px', sm: '14px', base: '16px', lg: '18px', xl: '20px', '2xl': '24px', '3xl': '30px', '4xl': '36px', '5xl': '48px', '6xl': '60px', '7xl': '72px', '8xl': '96px', '9xl': '128px' };
        const FONT_WEIGHTS = { thin: '100', extralight: '200', light: '300', normal: '400', medium: '500', semibold: '600', bold: '700', extrabold: '800', black: '900' };
        const LINE_HEIGHTS = { none: '1', tight: '1.25', snug: '1.375', normal: '1.5', relaxed: '1.625', loose: '2', '3': '0.75rem', '4': '1rem', '5': '1.25rem', '6': '1.5rem', '7': '1.75rem', '8': '2rem', '9': '2.25rem', '10': '2.5rem' };
        const LETTER_SPACING = { tighter: '-0.05em', tight: '-0.025em', normal: '0em', wide: '0.025em', wider: '0.05em', widest: '0.1em' };
        const DECORATION_THICKNESS = { auto: 'auto', 'from-font': 'from-font', '0': '0px', '1': '1px', '2': '2px', '4': '4px', '8': '8px' };
        const UNDERLINE_OFFSET = { auto: 'auto', '0': '0px', '1': '1px', '2': '2px', '4': '4px', '8': '8px' };
        const INDENT = { '0': '0px', 'px': '1px', '0.5': '0.125rem', '1': '0.25rem', '1.5': '0.375rem', '2': '0.5rem', '2.5': '0.625rem', '3': '0.75rem', '3.5': '0.875rem', '4': '1rem', '5': '1.25rem', '6': '1.5rem', '7': '1.75rem', '8': '2rem' };
        const BORDER_RADIUS = { none: '0px', xs: '0.125rem', sm: '0.125rem', md: '0.375rem', lg: '0.5rem', xl: '0.75rem', '2xl': '1rem', '3xl': '1.5rem', '4xl': '2rem', full: '9999px' };
        const BORDER_WIDTH = { '0': '0px', '1': '1px', '2': '2px', '4': '4px', '8': '8px' };
        const BLUR_SIZES = { none: '0', sm: '4px', default: '8px', md: '12px', lg: '16px', xl: '24px', '2xl': '40px', '3xl': '64px' };
        const TEXT_SHADOW_SIZES = {
            sm: '1px 1px 2px rgba(0, 0, 0, 0.5)',
            default: '2px 2px 4px rgba(0, 0, 0, 0.5)',
            md: '3px 3px 6px rgba(0, 0, 0, 0.5)',
            lg: '5px 5px 10px rgba(0, 0, 0, 0.5)',
            xl: '10px 10px 20px rgba(0, 0, 0, 0.5)',
            none: 'none'
        };

        const getSpacing = (val) => {
            if (val === undefined || val === null || val === '') return undefined;
            if (val === '0' || val === 0) return '0px';
            if (val === 'px') return '1px';
            if (val === 'auto') return 'auto';

            // Check for units - return as is if units are present
            if (typeof val === 'string' && (val.endsWith('px') || val.endsWith('rem') || val.endsWith('%') || val.endsWith('vh') || val.endsWith('vw'))) {
                return val;
            }

            const num = parseFloat(val);
            if (!isNaN(num)) return `${num * 0.25}rem`;
            return val;
        };

        const getSize = (val) => {
            if (val === undefined || val === null || val === '') return undefined;
            if (val === 'full') return '100%';
            if (val === 'screen') return '100vh';
            if (val === 'min') return 'min-content';
            if (val === 'max') return 'max-content';
            if (val === 'fit') return 'fit-content';
            if (typeof val === 'string' && val.includes('/')) {
                const [n, d] = val.split('/');
                return `${(parseFloat(n) / parseFloat(d)) * 100}%`;
            }
            return getSpacing(val);
        };

        const getColor = (value) => {
            if (!value) return undefined;
            const resolved = resolveColor ? resolveColor(value) : value;

            if (resolved && (resolved.startsWith('#') || resolved.startsWith('rgb') || resolved.startsWith('hsl'))) return resolved;

            const parts = value.split('-');
            if (parts.length >= 2) {
                const color = parts.slice(0, -1).join('-');
                const shade = parts[parts.length - 1];
                if (TAILWIND_COLORS[color] && TAILWIND_COLORS[color][shade]) {
                    return TAILWIND_COLORS[color][shade];
                }
            }

            return resolved;
        };

        const activeFilters = [];
        const activeBackdropFilters = [];

        let textShadowSize = null;
        let textShadowColorVal = null;
        let boxShadowSize = null;
        let boxShadowColorVal = null;
        let transitionProp = null;
        let durationVal = null;
        let easeVal = null;
        let delayVal = null;

        Object.entries(props).forEach(([key, value]) => {
            if (!value) return;

            switch (key) {
                // Typography
                case 'fontFamily':
                    if (value === 'sans') computedStyles.fontFamily = 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
                    else if (value === 'serif') computedStyles.fontFamily = 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
                    else if (value === 'mono') computedStyles.fontFamily = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';
                    break;
                case 'fontSize': computedStyles.fontSize = FONT_SIZES[value] || value; break;
                case 'fontWeight': computedStyles.fontWeight = FONT_WEIGHTS[value] || value; break;
                case 'fontStyle': if (value === 'italic') computedStyles.fontStyle = 'italic'; else if (value === 'not-italic') computedStyles.fontStyle = 'normal'; break;
                case 'textColor': computedStyles.color = getColor(value); break;
                // textAlign is handled by ComponentRenderer as flexbox properties
                case 'textAlign': computedStyles.textAlign = value; break;
                case 'textDecorationLine':
                    if (value === 'no-underline') computedStyles.textDecoration = 'none';
                    else computedStyles.textDecoration = value;
                    break;
                case 'textDecorationColor': computedStyles.textDecorationColor = getColor(value); break;
                case 'textDecorationStyle': computedStyles.textDecorationStyle = value; break;
                case 'textDecorationThickness': computedStyles.textDecorationThickness = DECORATION_THICKNESS[value] || value; break;
                case 'textUnderlineOffset': computedStyles.textUnderlineOffset = UNDERLINE_OFFSET[value] || value; break;
                case 'textTransform':
                    if (value === 'normal-case') computedStyles.textTransform = 'none';
                    else computedStyles.textTransform = value;
                    break;
                case 'lineHeight': computedStyles.lineHeight = LINE_HEIGHTS[value] || value; break;
                case 'letterSpacing': computedStyles.letterSpacing = LETTER_SPACING[value] || value; break;
                case 'textOverflow':
                    if (value === 'truncate') {
                        computedStyles.overflow = 'hidden';
                        computedStyles.textOverflow = 'ellipsis';
                        computedStyles.whiteSpace = 'nowrap';
                    } else if (value === 'text-ellipsis') {
                        computedStyles.textOverflow = 'ellipsis';
                    } else if (value === 'text-clip') {
                        computedStyles.textOverflow = 'clip';
                    }
                    break;
                case 'whiteSpace':
                    const wsValue = value.replace('whitespace-', '');
                    computedStyles.whiteSpace = wsValue;
                    break;
                case 'wordBreak':
                    const wbValue = value.replace('break-', '');
                    if (wbValue === 'normal') computedStyles.wordBreak = 'normal';
                    else if (wbValue === 'words') computedStyles.overflowWrap = 'break-word';
                    else if (wbValue === 'all') computedStyles.wordBreak = 'break-all';
                    else if (wbValue === 'keep') computedStyles.wordBreak = 'keep-all';
                    break;
                case 'textIndent': computedStyles.textIndent = INDENT[value] || value; break;
                case 'textShadow': textShadowSize = value; break;
                case 'textShadowColor': textShadowColorVal = getColor(value); break;
                // verticalAlign is handled by ComponentRenderer as flexbox properties
                case 'verticalAlign': computedStyles.verticalAlign = value; break;

                // Backgrounds
                case 'backgroundColor': computedStyles.backgroundColor = getColor(value); break;
                case 'opacity': computedStyles.opacity = parseInt(value) / 100; break;

                // Borders
                case 'borderColor':
                    computedStyles.borderColor = getColor(value);
                    if (!computedStyles.borderWidth) {
                        computedStyles.borderWidth = '1px';
                        computedStyles.borderStyle = 'solid';
                    }
                    break;
                case 'borderWidth': computedStyles.borderWidth = BORDER_WIDTH[value] || value; computedStyles.borderStyle = 'solid'; break;
                case 'borderRadius': computedStyles.borderRadius = BORDER_RADIUS[value] || value; break;
                case 'borderStyle': computedStyles.borderStyle = value; break;

                // Layout & Sizing
                case 'display': computedStyles.display = value; break;
                case 'width': computedStyles.width = getSize(value); break;
                case 'height': computedStyles.height = getSize(value); break;
                case 'minWidth': computedStyles.minWidth = getSize(value); break;
                case 'maxWidth': computedStyles.maxWidth = getSize(value); break;
                case 'minHeight': computedStyles.minHeight = getSize(value); break;
                case 'maxHeight': computedStyles.maxHeight = getSize(value); break;
                case 'padding': computedStyles.padding = getSpacing(value); break;
                case 'margin': computedStyles.margin = getSpacing(value); break;
                case 'position': computedStyles.position = value; break;
                case 'zIndex': computedStyles.zIndex = value; break;
                case 'top': computedStyles.top = getSpacing(value); break;
                case 'right': computedStyles.right = getSpacing(value); break;
                case 'bottom': computedStyles.bottom = getSpacing(value); break;
                case 'left': computedStyles.left = getSpacing(value); break;
                case 'inset':
                    computedStyles.top = getSpacing(value);
                    computedStyles.right = getSpacing(value);
                    computedStyles.bottom = getSpacing(value);
                    computedStyles.left = getSpacing(value);
                    break;
                case 'insetX':
                    computedStyles.left = getSpacing(value);
                    computedStyles.right = getSpacing(value);
                    break;
                case 'insetY':
                    computedStyles.top = getSpacing(value);
                    computedStyles.bottom = getSpacing(value);
                    break;
                case 'overflow': computedStyles.overflow = value; break;

                // Flex
                case 'flexDirection': computedStyles.flexDirection = value.replace('col', 'column'); break;
                case 'justifyContent': computedStyles.justifyContent = value === 'between' ? 'space-between' : (value === 'around' ? 'space-around' : (value === 'evenly' ? 'space-evenly' : value)); break;
                case 'alignItems': computedStyles.alignItems = value; break;
                case 'gap': computedStyles.gap = getSpacing(value); break;

                // Outline
                case 'outlineColor': computedStyles.outlineColor = getColor(value); break;
                case 'outlineWidth': computedStyles.outlineWidth = getSpacing(value); break;
                case 'outlineStyle': computedStyles.outlineStyle = value; break;
                case 'outlineOffset': computedStyles.outlineOffset = getSpacing(value); break;

                // Effects
                case 'shadow':
                case 'boxShadow':
                    boxShadowSize = value;
                    break;
                case 'boxShadowColor':
                    boxShadowColorVal = getColor(value);
                    break;

                // Filters
                case 'blur':
                    const b = BLUR_SIZES[value] || (value === 'default' ? '8px' : null);
                    if (b) activeFilters.push(`blur(${b})`);
                    break;
                case 'brightness': activeFilters.push(`brightness(${parseInt(value)/100})`); break;
                case 'contrast': activeFilters.push(`contrast(${parseInt(value)/100})`); break;
                case 'grayscale':
                    if (value === 'grayscale') activeFilters.push('grayscale(100%)');
                    else if (value === 'grayscale-0') activeFilters.push('grayscale(0)');
                    break;
                case 'hueRotate': activeFilters.push(`hue-rotate(${value}deg)`); break;
                case 'invert':
                    if (value === 'invert') activeFilters.push('invert(100%)');
                    else if (value === 'invert-0') activeFilters.push('invert(0)');
                    break;
                case 'saturate': activeFilters.push(`saturate(${parseInt(value)/100})`); break;
                case 'sepia':
                    if (value === 'sepia') activeFilters.push('sepia(100%)');
                    else if (value === 'sepia-0') activeFilters.push('sepia(0)');
                    break;

                // Backdrop Filters
                case 'backdropBlur':
                    const bb = BLUR_SIZES[value] || (value === 'default' ? '8px' : null);
                    if (bb) activeBackdropFilters.push(`blur(${bb})`);
                    break;
                case 'backdropBrightness': activeBackdropFilters.push(`brightness(${parseInt(value)/100})`); break;
                case 'backdropContrast': activeBackdropFilters.push(`contrast(${parseInt(value)/100})`); break;
                case 'backdropGrayscale':
                    if (value.includes('grayscale-0')) activeBackdropFilters.push('grayscale(0)');
                    else activeBackdropFilters.push('grayscale(100%)');
                    break;
                case 'backdropHueRotate': activeBackdropFilters.push(`hue-rotate(${value}deg)`); break;
                case 'backdropInvert':
                    if (value.includes('invert-0')) activeBackdropFilters.push('invert(0)');
                    else activeBackdropFilters.push('invert(100%)');
                    break;
                case 'backdropSaturate': activeBackdropFilters.push(`saturate(${parseInt(value)/100})`); break;
                case 'backdropSepia':
                    if (value.includes('sepia-0')) activeBackdropFilters.push('sepia(0)');
                    else activeBackdropFilters.push('sepia(100%)');
                    break;

                // Transitions
                case 'transitionProperty': transitionProp = value; break;
                case 'transitionDuration': durationVal = value; break;
                case 'transitionTimingFunction': easeVal = value; break;
                case 'transitionDelay': delayVal = value; break;
            }
        });

        if (activeFilters.length > 0) computedStyles.filter = activeFilters.join(' ');
        if (activeBackdropFilters.length > 0) computedStyles.backdropFilter = activeBackdropFilters.join(' ');

        if (boxShadowSize) {
            const SHADOW_MAP = {
                '2xs': '0 0 0 1px rgba(0, 0, 0, 0.05)',
                xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
                md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
                lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
                xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                none: 'none'
            };
            const shadowVal = boxShadowSize === 'default' ? 'md' : boxShadowSize;
            if (SHADOW_MAP[shadowVal]) {
                let shadow = SHADOW_MAP[shadowVal];
                if (boxShadowColorVal) {
                    // Replace standard colors (0.1, 0.05, 0.25 alpha) with custom color
                    // Simple replacement: replace rgba(...) with custom color
                    // Note: This replaces ALL shadows with solid color (losing alpha stacking usually)
                    // But Tailwind shadow colors apply to the whole shadow stack usually.
                    // Regex to find rgba pattern:
                    shadow = shadow.replace(/rgba\(0, 0, 0, [0-9.]+\)/g, boxShadowColorVal);
                }
                computedStyles.boxShadow = shadow;
            }
        }

        if (textShadowSize) {
             const ts = TEXT_SHADOW_SIZES[textShadowSize] || (textShadowSize === 'default' ? TEXT_SHADOW_SIZES.default : null);
             if (ts) {
                 if (textShadowColorVal) {
                     computedStyles.textShadow = ts.replace(/rgba\(0, 0, 0, 0.5\)/g, textShadowColorVal);
                 } else {
                     computedStyles.textShadow = ts;
                 }
             }
        }

        if (transitionProp) {
             const map = {
                 'transition-all': 'all',
                 'transition-none': 'none',
                 'transition-colors': 'color, background-color, border-color, text-decoration-color, fill, stroke',
                 'transition-opacity': 'opacity',
                 'transition-shadow': 'box-shadow',
                 'transition-transform': 'transform',
                 'transition': 'color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
                 // Keep shorthands just in case
                 'all': 'all',
                 'none': 'none',
                 'default': 'color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter'
             };
             computedStyles.transitionProperty = map[transitionProp] || transitionProp;
        }
        if (durationVal) computedStyles.transitionDuration = `${durationVal}ms`;
        if (easeVal) {
             const map = {
                 'linear': 'linear',
                 'in': 'cubic-bezier(0.4, 0, 1, 1)',
                 'out': 'cubic-bezier(0, 0, 0.2, 1)',
                 'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
             };
             computedStyles.transitionTimingFunction = map[easeVal] || easeVal;
        }
        if (delayVal) computedStyles.transitionDelay = `${delayVal}ms`;

        // Merge plugin styles with computed styles (plugin styles take precedence for colors)
        return { ...computedStyles, ...pluginStyles };
    }
}
